import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="bg-blue-900 text-white px-6 py-4 flex justify-between items-center">
      <Link to="/" className="flex items-center space-x-3 hover:text-blue-300">
        <img src="/logo.png" alt="Creative Town School Logo" className="h-10 w-10 rounded" />
        <span className="text-xl font-bold">Creative Town School</span>
      </Link>
      <ul className="flex space-x-6">
        <li>
          <Link to="/" className="hover:text-blue-300">Home</Link>
        </li>
        <li>
          <Link to="/about" className="hover:text-blue-300">About</Link>
        </li>
        <li>
          <Link to="/gallery" className="hover:text-blue-300">Gallery</Link>
        </li>
        <li>
          <Link to="/contact" className="hover:text-blue-300">Contact</Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;



